export default {
  title: 'Raport zespołu sprzedaży',
  fields: {
    name: 'Nazwa',
    area: 'Obszar',
    signed: 'Podpisane',
    live: 'Aktywne',
  },
  buttons: {
    download_report: 'Pobierz raport',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych, odśwież stronę',
  },
};
